const mensagens = require('./i18n/message_pt')
const mensagensIngles = require('./i18n/message_en')
const mensagensEspanhol = require('./i18n/message_es')
const mensagensFrances = require('./i18n/message_fr')

const mensagensPorIdioma = {
    en: mensagensIngles,
    pt: mensagens,
    es: mensagensEspanhol,
    fr: mensagensFrances
}

const retornarTexto = (idioma = 'pt', codigoMensagem, ...params) => {
    const mensagensIdiomaAtual = mensagensPorIdioma[idioma]
    let mensagem = mensagensIdiomaAtual[codigoMensagem]

    if (mensagem) {
        params.forEach((parametro) => {
            mensagem = mensagem.replace('%param', parametro)
        })

        return mensagem
    }

    return mensagensIdiomaAtual.erro_msgNaoEncontrada
}

module.exports = { retornarTexto }